import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
function ArrowDropDown(_ref) {
  let {
    color = '#788590',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.775 0l-5 6-5-6h10z",
    fill: color
  }));
}
export default ArrowDropDown;